module.exports = __webpack_public_path__ + "img/invite-import.e8d72c11.png";